import { render, staticRenderFns } from "./wanedit.vue?vue&type=template&id=caa01f22"
import script from "./wanedit.vue?vue&type=script&lang=js"
export * from "./wanedit.vue?vue&type=script&lang=js"
import style0 from "./wanedit.vue?vue&type=style&index=0&id=caa01f22&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports